import { Injectable } from '@angular/core';
import { BehaviorSubject, debounceTime, filter } from 'rxjs';
import { ProductReference } from "../models/layout/product-reference";
import { LayoutService } from './layout.service';

export interface InspectedProductLocation {
    dropIndex: number;
    shelfIndex: number;
    stackIndex: number,
    productIndex: number;
}

@Injectable({ providedIn: 'root' })
export class ProductInspectorService {
    private productId = new BehaviorSubject<number | null>(null);
    private productLocation = new BehaviorSubject<InspectedProductLocation | null>(null);
    private productReference: ProductReference | null = null;
    private openSource = new BehaviorSubject<boolean>(false);
    inspectedProduct$ = this.productId.asObservable()
    inspectedProductLocation$ = this.productLocation.asObservable();
    isOpen$ = this.openSource.asObservable();

    private scrollToElementSource = new BehaviorSubject<HTMLElement | null>(null);

	constructor(private layoutService: LayoutService){ 
        // Debounced scroll handling
        this.scrollToElementSource
            .pipe(
                debounceTime(100),
                filter((el): el is HTMLElement => el !== null)
            )
            .subscribe(element => {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            });
    }

     /**
     * Call this to request a debounced scroll into view
     */
    requestScrollIntoView(element: HTMLElement | null) {
        if (element) {
            this.scrollToElementSource.next(element);
        }
    }

    inspect(productId: number, inspectedProductLocation: InspectedProductLocation | null = null) {
        const productRef = this.layoutService.planogramItems.get(productId);
        if (!productRef) return;

        this.productReference = productRef;
        this.productId.next(productRef.productId);
        this.productLocation.next(inspectedProductLocation);
        this.openSource.next(true);
    }

    getInspectedProductLocation(): InspectedProductLocation | null {
        return this.productLocation.value;
    }

    getProductReference() {
        return this.productReference;
    }

    close() {
        this.productId.next(-1);
        this.openSource.next(false);
        this.productLocation.next(null);
        this.productReference = null;
    }
}